import { render, staticRenderFns } from "./HistoricDeviceReport.vue?vue&type=template&id=53320130"
import script from "./HistoricDeviceReport.vue?vue&type=script&lang=js"
export * from "./HistoricDeviceReport.vue?vue&type=script&lang=js"
import style0 from "./HistoricDeviceReport.vue?vue&type=style&index=0&id=53320130&prod&scyAxed=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports